import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Cupom } from '@mobile/app/shared/types/cupom.type';

@Injectable({ providedIn: 'root' })
export class CuponsFirebaseService {
  constructor(private afs: AngularFirestore) {}

  /** Cupons com o código informado; `null` quando não existe. */
  async getCupom(cupom: string): Promise<Cupom[] | null> {
    const snapshot = await this.afs.firestore.collection('Cupom').where('cupom', '==', cupom).get();
    return snapshot.empty ? null : snapshot.docs.map(d => d.data() as Cupom);
  }
}
